import React, { useState } from 'react';
import { FiPlus, FiLayers } from 'react-icons/fi';
import ProductsSidebar from '../components/ProductsSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [];

export default function Stock() {
  const [data, setData] = useLocalState('stock_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'asc' });

  const handleAdd = (newData) => setData([{ ...newData, status: 'Active' }, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <ProductsSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiLayers className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Warehouses ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('name')} className="p-2 border border-black text-left cursor-pointer">Name</th>
                <th onClick={() => handleSort('location')} className="p-2 border border-black text-left cursor-pointer">Location</th>
                <th onClick={() => handleSort('items')} className="p-2 border border-black text-right cursor-pointer">Items</th>
                <th onClick={() => handleSort('value')} className="p-2 border border-black text-right cursor-pointer">Value</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.ref}</td>
                  <td className="p-2 border border-black">{row.name}</td>
                  <td className="p-2 border border-black">{row.location}</td>
                  <td className="p-2 border border-black text-right">{row.items}</td>
                  <td className="p-2 border border-black text-right font-medium">{row.value}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-green-100 px-2 py-0.5 rounded text-green-800">{row.status}</span></td>
                </tr>
              ))}
              {sortedData.length === 0 && <tr><td colSpan="6" className="p-4 text-center text-gray-500">No warehouses found.</td></tr>}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Warehouse" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'name', label: 'Name' }, { name: 'location', label: 'Location' },
          { name: 'items', label: 'Items Count' }, { name: 'value', label: 'Total Value' }
        ]} />
      </div>
    </div>
  );
}